var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-empty',{attrs:{"image":"error","description":_vm.description}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }